// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"r4-z"};